import "jQuery";

'use strict';

(function($) {
    $(document).ready(function() {
        $('img[data-hotspot-x]').each(function() {
            let $img = $(this);
            let hotspot_x = $img.data('hotspot-x');
            let hotspot_y = $img.data('hotspot-y');
            let x_pos = 50;
            let y_pos = 50;
            if(hotspot_x !== undefined) {
                x_pos = hotspot_x * 100 / $img.get(0).naturalWidth;
            }
            if(hotspot_y !== undefined) {
                y_pos = hotspot_y * 100 / $img.get(0).naturalHeight;
            }
            x_pos = x_pos > 100 ? 100 : x_pos;
            y_pos = y_pos > 100 ? 100 : y_pos;
            $img.css('object-position', x_pos + '%' + y_pos + '%');
        });
    });
})( jQuery );